import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadCostshareDetails, loadRxDetails } from '../../Services/loadOrder';
import MenuBar from './MenuBar';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import "../../assets/css/home.css";
import toast ,{ Toaster} from 'react-hot-toast'; 
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const CostShareDetails = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [names, setNames] = useState([]); // For dropdown values
  const [selectedName, setSelectedName] = useState("");
  const [searchText, setSearchText] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const navigate = useNavigate(); // 
  const user = JSON.parse(localStorage.getItem('user'));
  const pharmacyId = user?.pharmacyId;

  const columns = [
    { field: 'MemberID', headerName: 'Member ID', flex:1, headerClassName: 'pink-header' },
    { field: 'FirstName', headerName: 'First Name',flex:1, headerClassName: 'pink-header' }, 
    { field: 'LastName', headerName: 'Last Name', flex:1, headerClassName: 'pink-header' },
    { field: 'AuthorizationNumber', headerName: 'AuthorizationNumber',flex:1, headerClassName: 'pink-header' },
    { field: 'MemberDOB', headerName: 'MemberDOB', flex:1, headerClassName: 'pink-header' },
    { field: 'Contract', headerName: 'Contract', flex:1, headerClassName: 'pink-header' }
];

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!pharmacyId) return;

        const orderResponse = await LoadCostshareDetails(pharmacyId, "", "");
        setNames(orderResponse?.Name || []); // Save Names for dropdown
        console.log("Cost Share Details Response:", orderResponse?.Name );
        const data = orderResponse?.TaskDetail;
        if (Array.isArray(data)) {
          const formattedRows = data.map((item, id) => ({
            id: id + 1,
            MemberID: item.MemberID || '',
            FirstName: item["First Name"] || '',
            LastName: item["Last Name"] || '',
            AuthorizationNumber: item.AuthorizationNumber || '',
            MemberDOB: item.MemberDOB || '',
            Contract: item.Contract || ''
          }));
          setRows(formattedRows);
        } else {
          console.log("Unexpected data structure:", orderResponse);
        }
      } catch (error) {
        console.error("Failed to load cost share details:", error);
        navigate('/error-page'); // Navigate to error page on failure
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleRowClick = async (params) => {
    const row = params.row;
    console.log("Row clicked:", row);
    const contract = row.Contract;
    const MemberID = row.MemberID;
    const pharmacyID = pharmacyId;
    console.log("Navigating to cost share info with:", { MemberID, contract, pharmacyID });

    if (!contract || !MemberID || !pharmacyID) {
      toast.error("Missing required task or user data.");
      navigate('/error-page');
      return;
    }

    try {
      console.log("cost-share-info");
      navigate('/cost-share-info', {
        state: {
          MemberID,
          contract,
          pharmacyId
        }
      });
    } catch (err) {
      console.error("Failed to cost share details:", err);
      toast.error("Error loading cost share details.");
      navigate('/error-page'); // Navigate to error page on failure
    }
  };

  // Search handler
  const handleSearch = async () => {
    if (!selectedName || !searchText) {
      toast.error("Please enter your search criteria");
      return;
    }
    setSearchLoading(true);
    try {
      const orderResponse = await LoadCostshareDetails(pharmacyId, selectedName, searchText);
      const data = orderResponse?.TaskDetail;
      if (Array.isArray(data)) {
        const formattedRows = data.map((item, id) => ({
          id: id + 1,
          MemberID: item.MemberID || '',
          FirstName: item["First Name"] || '',
          LastName: item["Last Name"] || '',
          AuthorizationNumber: item.AuthorizationNumber || '',
          MemberDOB: item.MemberDOB || '',
          Contract: item.Contract || ''
        }));
        setRows(formattedRows);
      } else {
        setRows([]);
        toast.error("No data found for the search.");
      }
    } catch (error) {
      toast.error("Error searching cost share details.");
    } finally {
      setSearchLoading(false);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <Toaster position="top-right" />
      <MenuBar />
      <div className='top-page-option'>
        <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center' }}>
         <a 
            href="#/home" 
            style={{
              textDecoration: 'none',
              color: '#ec088c',
              display: 'inline-flex',
              alignItems: 'center'
            }}
          >
            <ChevronLeft color='#ec088c' size={18} />
            <span style={{ marginLeft: '5px' }}>Back</span>
          </a>
        </div>

        <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center', gap: '6px', width: '80%' }}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            Dispensed Orders
            <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px', marginLeft: '4px', marginRight: '4px' }} />
            Cost Share Details
          </span>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              marginLeft: 'auto',
              marginRight: '-15.5%', // Aligns controls to the right edge of the parent
              flexWrap: 'nowrap'
            }}
          >
            <FormControl size="small" sx={{ minWidth: 100, height: '30px', background: '#fff', borderRadius: '4px', marginRight: '10px' }}>
              <InputLabel sx={{ fontFamily: 'Calibri', marginBottom: '10px', background: '#fff', color: 'black', fontSize: '12px' }}>
                --Select--
              </InputLabel>
              <Select
                value={selectedName}
                onChange={(e) => setSelectedName(e.target.value)}
                label="Select"
                sx={{
                  fontFamily: 'segoe ui',
                  fontSize: '12px',
                  borderRadius: '15px',
                  border: '1px solid rgb(236, 151, 202)',
                  height: '30px',
                  boxShadow: 'none',
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ec008c',
                    boxShadow: '0 0 6px rgba(236, 0, 140, 0.4)',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#ec008c',
                  },
                }}
              >
                <MenuItem value="" sx={{ fontSize: '12px', '&:hover': { backgroundColor: '#f5f5f5' } }}>
                  --Select--
                </MenuItem>
                {names.map((nameObj, idx) => (
                  <MenuItem key={idx} value={nameObj.Name} sx={{ fontSize: '12px',  '&:hover': { backgroundColor: '#f5f5f5' } }}>
                    {nameObj.Name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <input
              type="text"
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') handleSearch(); }}
              style={{
                padding: '5px 5px',
                borderRadius: '15px',
                border: '1px solid rgba(236, 151, 202)',
                outline: 'none',
                transition: 'all 0.3s ease',
                marginRight: '8px'
              }}
              onFocus={e => {
                e.target.style.border = '1px solid #ec008c';
                e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
              }}
              onBlur={e => {
                e.target.style.border = '1px solid rgb(236, 151, 202)';
                e.target.style.boxShadow = '0 1px 2px rgb(236, 151, 202)';
              }}
            />
            <button
              onClick={handleSearch}
              disabled={searchLoading}
              style={{ padding: '6px 18px', borderRadius: '4px', background: '#ec008c', color: 'white', border: 'none', cursor: 'pointer', marginRight: '8px' }}
            >
              {searchLoading ? <>
      Searching&nbsp;&nbsp;
      <CircularProgress size={15} sx={{ color: '#fff' }} />
    </> : 'Search'}
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{ padding: '5px 18px', borderRadius: '4px', background: '#ec008c', color: 'white', border: 'none', cursor: 'pointer' }}
            >
              View All
            </button>
          </div>
        </div>
      </div>

      <div style={{height: '60vh', width: '85%', margin: 'auto' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[10, 25, 50]}
          disableSelectionOnClick
          onRowClick={handleRowClick}
          sx={{
            fontSize: '12px',
            fontFamily: 'Segoe UI',
            '& .pink-header': {
              color: '#fff',
              backgroundColor: '#ec008c',
              fontWeight: 'bold',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              lineHeight: 1.2,
              textAlign: 'center',
              padding: '8px 2px',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#f5f5f5 !important',
              cursor: 'pointer',
            },
            '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
              outline: 'none !important',
              boxShadow: 'none !important',
            },
            '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
              outline: 'none !important',
              boxShadow: 'none !important',
            },
          }}
        />
      </div>
      {searchLoading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(255,255,255,0.7)',
          zIndex: 3000,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            border: '6px solid #f3f3f3',
            borderTop: '6px solid #EC088C',
            borderRadius: '50%',
            width: 48,
            height: 48,
            animation: 'spin 1s linear infinite'
          }} />
          <div style={{marginTop: 24, fontSize: '1.2rem', fontWeight: 500, color: '#222'}}>Searching...</div>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
        </div>
      )}
      {loading && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(255,255,255,0.7)',
          zIndex: 2000,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{
            border: '6px solid #f3f3f3',
            borderTop: '6px solid #EC088C',
            borderRadius: '50%',
            width: 48,
            height: 48,
            animation: 'spin 1s linear infinite'
          }} />
          <div style={{marginTop: 24, fontSize: '1.2rem', fontWeight: 500, color: '#222'}}>Your request is being processed</div>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg);} 100% {transform: rotate(360deg);} }`}</style>
        </div>
      )}
    </div>
  );
}; 

export default CostShareDetails;